
import arrayMixin from './arrayMixin';
import { productCategoryIndexAPI } from '@/api/admin/crm';

export default {
  name: 'XhProducCate', // 新建 产品分类
  components: {},
  mixins: [arrayMixin],
  props: {},
  data: function data() {
    return {
      options: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        value: 'category_id'
      }
    };
  },

  computed: {},
  watch: {},
  mounted: function mounted() {
    this.getProductCategoryIndex();
  },

  methods: {
    /** 获取产品分类数据 */
    getProductCategoryIndex: function getProductCategoryIndex() {
      var _this = this;

      productCategoryIndexAPI({
        type: 'tree'
      }).then(function (res) {
        _this.options = res.data;
      }).catch(function () {});
    },
    valueChange: function valueChange(val) {
      this.$emit('value-change', {
        index: this.index,
        item: this.item,
        value: val,
        valueContent: this.$refs.elCascader.getCheckedNodes()[0].label // 参考 https://segmentfault.com/q/1010000013063478
      });
    }
  }
};